import { useState,useEffect } from "react";
import { ArticleCard } from "../../ui-kit/ArticleCard/ArticleCard";

import { getArticles } from "../../app/api";

import styles from "./Articles.module.scss";



export const Articles = () => {
  const BASE_URL = process.env.NODE_ENV === 'production' 
                      ? process.env.REACT_APP_BASE_URL_PROD 
                      : process.env.REACT_APP_BASE_URL_DEV;
  const [articles, setArticles] = useState([]);
  const [offsetPage, setOffsetPage] = useState(0);
  const [totalArticles, setTotalArticles] = useState(0);
  const [needLoad, setNeedLoad] = useState(null);

  const [isLoading, setIsLoading] = useState(false);
  const [shouldLoad, setShouldLoad] = useState(true);

  useEffect(() => {
    async function loadArticles() {
      //console.log('Первый вызов функции loadArticles');
      try {
        const data = await getArticles(0);
        //console.log('Статьи загружены с сервера (1 порция): ', data);
        setTotalArticles(data.meta.total_count);

        //console.log("Общее кол-во статей на сервере: ", data.meta.total_count);
        setArticles(data.items);
        setNeedLoad(false);
        setOffsetPage(10);

      } catch (e) {
        console.error("Ошибка при загрузке списка статей: ", e);
      }
    };

    loadArticles();

  }, []);

  useEffect(()=>{

    if (totalArticles> 0 && offsetPage >= totalArticles){
      //console.log("Новый офсет:", offsetPage);
      console.log("Все материалы загружены. Запрещаем загрузку");
      setShouldLoad(false);
    }
  },[offsetPage])


  useEffect(()=>{
    async function reloadArticles(offsetPage) {

      if (isLoading || !shouldLoad) return

      console.log('Начинаю дозагрузку статей через вызов функции reloadArticles');
      try {
        setIsLoading(true);
        const data = await getArticles(offsetPage);
        //console.log('Дополнительные статьи загружены с сервера: ', data);

        //console.log("Добавляем статьи в articles");
        let newArticles = [...articles, ...data.items];
        setArticles(newArticles);
        setOffsetPage(offsetPage + 10);
        setNeedLoad(false);
        setIsLoading(false);
      } catch (e) {
        console.error("Ошибка при загрузке списка статей: ", e);
      }
    };

    if (needLoad){
      reloadArticles(offsetPage);
    }

  }, [needLoad]);


  useEffect(() => {
    async function checkPosition(){
      const height = document.body.offsetHeight;
      const screenHeight = window.innerHeight;

      // Сколько пикселей уже проскроллили
      const scrolled = window.scrollY;

      // Порог
      const threshold = height - screenHeight / 4;

      // Низ экрана относительно страницы
      const position = scrolled + screenHeight;

      //console.log(height, screenHeight, scrolled, threshold, position);

      if (position >= threshold) {
        console.log("Дозагрузка")
        setNeedLoad(true);
      }
    }

    function throttle(callee, timeout) {
      let timer = null

      return function perform(...args) {
        if (timer) return

        timer = setTimeout(() => {
          callee(...args)

          clearTimeout(timer)
          timer = null
        }, timeout)
      }
    }

    window.addEventListener('scroll', throttle(checkPosition, 250))
    window.addEventListener('resize', throttle(checkPosition, 250))
  }, []);


  console.log(articles[0]);
  return (
    articles && articles.length > 0 && (
    <div className={styles.articles}>
      {articles.map((article) => (
        <ArticleCard
          key={article.id}
          href={`/articles/${article.id}`}
          title={article.title}
          src={ BASE_URL + article.main_image.meta.download_url}
          dtString={article.meta.first_published_at}
          categories={articles.categories}
        />
      ))}
    </div>)
  );
};
